var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Differentiators/Working/Active/48px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Differentiators/Working/Active/48px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.262500, 9.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9123047,9.75 C15.9123047,12.9814553 13.29376,15.6 10.0623047,15.6 C6.8308494,15.6 4.21230469,12.9814553 4.21230469,9.75 C4.21230469,6.51994725 6.8308494,3.9 10.0623047,3.9 C13.29376,3.9 15.9123047,6.51994725 15.9123047,9.75 Z",
    id: "Stroke-9",
    stroke: "#DE3518"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DB3725",
    x: 9.57480469,
    y: 0,
    width: 1,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#DB3725",
    x: 9.57480469,
    y: 15.6,
    width: 1,
    height: 3.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "#DB3725",
    transform: "translate(1.950000, 9.750000) rotate(-270.000000) translate(-1.950000, -9.750000) ",
    points: "1.4625 7.8 2.4375 7.8 2.4375 11.7 1.4625 11.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    fill: "#DB3725",
    transform: "translate(18.349805, 9.750000) rotate(-270.000000) translate(-18.349805, -9.750000) ",
    points: "17.8623047 7.8 18.8373047 7.8 18.8373047 11.7 17.8623047 11.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    fill: "#DB3725",
    transform: "translate(15.912305, 15.600000) rotate(-45.000000) translate(-15.912305, -15.600000) ",
    points: "15.4248047 13.65 16.3998047 13.65 16.3998047 17.55 15.4248047 17.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#DB3725",
    transform: "translate(15.424805, 3.900000) rotate(-315.000000) translate(-15.424805, -3.900000) ",
    points: "14.9373047 1.95 15.9123047 1.95 15.9123047 5.85 14.9373047 5.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-7",
    fill: "#DB3725",
    transform: "translate(4.699805, 3.900000) scale(-1, 1) rotate(-315.000000) translate(-4.699805, -3.900000) ",
    points: "4.21230469 1.95 5.18730469 1.95 5.18730469 5.85 4.21230469 5.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    fill: "#DB3725",
    transform: "translate(4.212305, 15.600000) scale(-1, -1) rotate(-315.000000) translate(-4.212305, -15.600000) ",
    points: "3.72480469 13.65 4.69980469 13.65 4.69980469 17.55 3.72480469 17.55"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,3.9 C23.4,6.05464415 21.6534271,7.8 19.5007839,7.8 C17.3465729,7.8 15.6,6.05464415 15.6,3.9 C15.6,1.74535585 17.3465729,0 19.5007839,0 C21.6534271,0 23.4,1.74535585 23.4,3.9 Z",
    id: "Stroke-11",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,27.5272807 C7.8,29.6819249 6.05499497,31.4272807 3.90078392,31.4272807 C1.74657286,31.4272807 0,29.6819249 0,27.5272807 C0,25.3726366 1.74657286,23.6272807 3.90078392,23.6272807 C6.05499497,23.6272807 7.8,25.3726366 7.8,27.5272807 Z",
    id: "Stroke-13",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6801453,28.7460307 C38.6801453,30.9006749 36.9335724,32.6460307 34.7809292,32.6460307 C32.6267181,32.6460307 30.8801453,30.9006749 30.8801453,28.7460307 C30.8801453,26.5913866 32.6267181,24.8460307 34.7809292,24.8460307 C36.9335724,24.8460307 38.6801453,26.5913866 38.6801453,28.7460307 Z",
    id: "Stroke-15",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2604858,32.1470133 C29.4475319,35.1171217 25.4816523,36.968194 21.0857376,36.968194 C18.7536833,36.968194 16.5433952,36.4475313 14.5627674,35.5150012",
    id: "Stroke-17",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,4.3875 C30.2443803,6.12533491 35.0227147,9.4784194 35.9345581,18.2486389",
    id: "Stroke-19",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4210726,24.0487843 C2.065022,22.7354711 1.87389528,21.3522181 1.87389528,19.925447 C1.87389528,14.6799651 4.44331668,10.0390735 8.38453475,7.21506145",
    id: "Stroke-21",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-23",
    stroke: "#001823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4.81075478 6.71979036 8.71075478 6.71979036 8.71075478 10.6197904"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-23-Copy",
    stroke: "#001823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(35.511395, 16.087500) rotate(-235.000000) translate(-35.511395, -16.087500) ",
    points: "33.5613953 14.1375 37.4613953 14.1375 37.4613953 18.0375"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-23-Copy-2",
    stroke: "#001823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(16.498895, 36.318750) rotate(-111.000000) translate(-16.498895, -36.318750) ",
    points: "14.5488953 34.36875 18.4488953 34.36875 18.4488953 38.26875"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/Working.c1ac319542b277d4798c130ac7bcda32.svg";
export { ForwardRef as ReactComponent };